export class RegiaoModel {
    id?: number;
    descricao?: string;
    ativo?: boolean;
    usuarioCadastro?: string;
    dataCadastro?: Date;
    usuarioAlteracao?: string;
    dataAlteracao?: Date;
}